import React, {Component} from "react"
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PlanChoice from "./planChoice";
import PlanSelect from "./planSelect";

const mapStateToProps = (state, ownProps) => {
    const {initialData} = state;
    const isBrellaChoice = !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice";
    return {
        ...ownProps,
        isBrellaChoice,
    }
};

class Plan extends Component {
    render() {
        const {isBrellaChoice, ...rest} = this.props;
        return isBrellaChoice ? <PlanChoice {...rest}/> : <PlanSelect {...rest}/>
    }
}

export default withRouter(connect(mapStateToProps)(Plan));
